import { AxiosResponse } from 'axios';
import axios from 'axios';
import { config } from '../../../config/environment';
import { ILoginApiPayload, ILoginApiResponse, ISignUpPayload } from '../Interfaces/ILoginCreds';

/**
 *
 *
 *
 * New Authentication
 *
 *
 * */

export const getOtpWithoutContact = (email: string) => {
  const res = axios.post(`${config.apiBaseUrl}/v1/otpwithoutsaving?email=${email}`);
  return res;
};

export const verifyOtpWithoutContact = (email: string, otp: string) => {
  const res = axios.get(`${config.apiBaseUrl}/v1/verifyotpwithoutcontact?contact=${email}&otpEnteredEmail=${otp}`);
  return res;
};

export const getOtp = (email: string) => {
  const res = axios.post(`${config.apiBaseUrl}/v1/auth/send/otp?email=${email}&update=true`);
  return res;
};

export const verifyOtp = (email: string, otp: string) => {
  const res = axios.post(`${config.apiBaseUrl}/v1/auth/verify/otpwithContact?email=${email}&otp=${otp}`);
  return res;
};

export const login: (payload: ILoginApiPayload) => Promise<AxiosResponse<ILoginApiResponse>> = async (payload: ILoginApiPayload) => {
  const path = `${config.apiBaseUrl}/v1/login`;
  const getLoginResponse = await axios.post(path, payload);
  return getLoginResponse;
};

export const saveContact = (payload: ISignUpPayload) => {
  const res = axios.post(`${config.apiBaseUrl}/v1/application/startup`, { applicant: payload });
  return res;
};

// Logout Api

export const logout: (refreshToken: string) => Promise<AxiosResponse<ILoginApiResponse>> = (refreshToken: string) => {
  const path = `${config.apiBaseUrl}/v1/logout`;
  const payload = { refreshtoken: refreshToken };
  const logout = axios.post(path, payload);
  return logout;
};

// Get Application and Meeting Details(GET)

export const getMeetings: (data: string) => Promise<AxiosResponse> = async (data: string) => {
  const path = `${config.apiBaseUrl}/v1/jury/evaluation/meeting`;
  const res: AxiosResponse = await axios.get(path, {
    params: { contactid: data },
  });
  return res;
};

//Get Startup Details (GET)

export const getStartupDetail: (data: string) => Promise<AxiosResponse> = async (data: string) => {
  const path = `${config.apiBaseUrl}/v1/jury/evaluation/application`;
  const res: AxiosResponse = await axios.get(path, {
    params: {
      applicationid: data,
    },
  });
  return res;
};

//Get application details for stepper (GET)

// export const getApplicationDetails: (applicationid: string) => Promise<AxiosResponse> = async () => {
//   const path = `${config.apiBaseUrl}/v1/jury/evaluation/application`;
//   const res: AxiosResponse = await axios.get(path);
//   return res;
// };

export const getApplicationDisplayFields: () => Promise<AxiosResponse> = async () => {
  const path = `${config.apiBaseUrl}/v1/jury/application/fields`;
  const res: AxiosResponse = await axios.get(path);
  return res;
};

//Get Pitch Desk for Stepper (GET)

export const getPitchDesk: (docid: string) => Promise<AxiosResponse> = async (docid: string) => {
  const path = `${config.apiBaseUrl}/v1/jury/application/document?docid=${docid}`;
  const res: AxiosResponse = await axios.get(path);
  return res;
};

//Additional Documents for stepper (GET)

// export const getAdditionalDetails: (applicationid: string) => Promise<AxiosResponse> = async () => {
//   const path = `${config.apiBaseUrl}/v1/jury/evaluation/application`;
//   const res: AxiosResponse = await axios.get(path, {
//     params: {
//       applicationid: 'a1o9I000002kFkWQAU',
//     },
//   });
//   return res;
// };

//Get Feedback (GET)

export const getFeedback: (contactid: string, applicationid: string, round: string) => Promise<AxiosResponse> = async (contactid: string, applicationid: string, round: string) => {
  const path = `${config.apiBaseUrl}/v1/jury/evaluation/feedbacks`;
  const res: AxiosResponse = await axios.get(path, {
    params: {
      contactid: contactid,
      applicationid: applicationid,
      round: round,
    },
  });
  return res;
};

//Get Admin Scores (GET) - every juror's individual score for an application,
//for admin reporting (not exposed to a regular jury member's own evaluation view).

export const getAdminScores: (applicationid: string, round: string) => Promise<AxiosResponse> = async (applicationid: string, round: string) => {
  const path = `${config.apiBaseUrl}/v1/jury/evaluation/adminscores`;
  const res: AxiosResponse = await axios.get(path, {
    params: {
      applicationid: applicationid,
      round: round,
    },
  });
  return res;
};

//Post Feedback (POST)

export const postFeedback: (payload: any) => Promise<AxiosResponse> = async (payload: any) => {
  const path = `${config.apiBaseUrl}/v1/jury/evaluation/save`;
  const res: AxiosResponse = await axios.post(path, payload);
  return res;
};

// Get the instructions
export const getInstructions: () => Promise<AxiosResponse> = async () => {
  const path = `${config.apiBaseUrl}/v1/jury/get/instruction`;
  const res: AxiosResponse = await axios.get(path);
  return res;
};

export const getFounders: () => Promise<AxiosResponse> = async () => {
  const path = `${config.apiBaseUrl}/v1/jury/get/founder`;
  const res: AxiosResponse = await axios.get(path);
  return res;
};
